import React from "react";


export class ErrorBoundary extends React.Component<{ children: React.ReactNode }> {
    state = { hasError: false };
  
    static getDerivedStateFromError(error: Error) {
      console.log(error);
      
      return { hasError: true };
    }
  
    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
      console.error(error, errorInfo);
    }
  
    render() {
      if (this.state.hasError) {
        return <h1>Something went wrong in SchedulingConfirm!</h1>;
      }
  
      return this.props.children;
    }
  }
  